import React from 'react'
import ShieldIcon from 'components/material-symbol/icons/Shield'
import { PGA_COM_HOST } from 'env'
import AccountCard from './account-card'
import AccountLinkRow from 'components/account-link-row'

const PLATFORM_POLICIES_URL = `${PGA_COM_HOST}/platform-user-policies`

const LegalPolicies = ({ classes }) => (
  <AccountCard title="Legal & Policies" classes={classes}>
    <AccountLinkRow
      href={PLATFORM_POLICIES_URL}
      icon={<ShieldIcon />}
      title="Platform Policies"
      description="Security, privacy, and account handling information."
    />
  </AccountCard>
)

export default LegalPolicies
